// extracted by mini-css-extract-plugin
module.exports = {"chart":"chart_chart__3T49i","chartHeader":"chart_chartHeader__2HXLN","label":"chart_label__2dQdk"};